import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ModalHeader, ModalFooter } from '@gnb/components/Common';
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue';
import PersonalInfoView from './PersonalInfoView.vue';

import { mapGetters, mapActions } from 'vuex';
import * as types from '@gnb/store/types';
import api from '@gnb/api';

@Component({
  components: {
    ModalHeader,
    ModalFooter,
    PreferenceContentTemplate,
    PersonalInfoView,
  },
  methods: {
    ...mapActions({
      loading: types.COMMON_LOADDING,
    }),
  },
  computed: {
    ...mapGetters({
      isLoading: types.COMMON_LOADDING,
    }),
  },
})
export default class PersonalInfo extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    loading!: (option: boolean) => void;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    isLoading!: boolean;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    header: string = this.$t('개인_정보_설정').toString();
    personalInfo: kyobobook.PersonalInfo | null = null;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    load() {
        this.loading(true);

        api.kyobobook.getPersonalInfo().then((res) => {
            if(res) {
                this.personalInfo = res;
                this.personalInfo = {
                    photoPath: res.photoPath,
                    officeTel: res.officeTel ?? '',
                    officeAddress: res.officeAddress ?? '',
                    mobileTel: res.mobileTel ?? '',
                    jobRoleName: res.jobRoleName ?? ''
                };
    
                this.loading(false);
            };
        });
    }

    save() {
        this.loading(true);
        let info = (this.$refs.refInfoView as any).getInfo();
        api.kyobobook.setPersonalInfo(info).then((res) => {
            if(res > 0) {
                (window as any).alertAsync(this.$t('적용되었습니다').toString());
                this.load();
            }
        }).finally(() => {
            this.loading(false);
        })
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.load();
    }
}
